export function composeReducers(initialState: any, ...reducers: any) {
  return (state = initialState, action) =>
    reducers.reduce((state, reducer) => reducer(state, action), state);
}
